import classes from "./ResponseSelect.module.css";
import React, { useEffect, useState } from "react";
import Collapsable from "./collapsable";
import axios from "../../Axios";
import Draggable from "./draggable";
import loadSwitch from "./Responses/switchLoader";
import responseLoader from './Responses/responseLoader'
import {useSelector} from 'react-redux'
import { Switch, InputNumber } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import Backdrop from "../utils/backdrop";
const Response = ({
  visible,
  optionChangeHandler,
  selected,
  deleteHandler,
  mandatoryHandle,
  checked,
  layoverSwitch
}) => {
  const responseList = useSelector(state=>state.responses);
  console.log("[Redux from responses]", responseList);
  let options = {};
  const [drawer, setDrawer] = useState(false);
  const switches = { ...loadSwitch };

  let backrop = null;
  if (visible) {
    backrop = <Backdrop clickHandler={layoverSwitch} />;
     
  }
  let glitchRemoval = null;

  useEffect(() => {
    glitchRemoval = classes.noGlitch;
    const func = (e)  => {
      if (e.key.toLowerCase() === "escape") layoverSwitch();
    }
    const fetchFunc = async () => {
      const fetchData = await axios.post("/response/fetch", {
        fetchType: 0,
      });

      
    };

    fetchFunc();

    return ()=>{
      window.removeEventListener("keydown", func);
    }
  }, []);

  const tempOptions = {};
      const payload = responseList;
      if (payload) {
        payload.map((option) => {
          return (tempOptions[option["_id"]] = {
            responses: [...option.responses],
            type: option.type,
          });
        });

        options = { ...tempOptions };
      }
  const newReponseHandler = () => {
    setDrawer(!drawer);
  };

  const switchInputs = Object.keys(switches).map((single) => {
    return (
      <div className={classes.switchHolder}>
        <p>{single}</p>
        <Switch
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          onChange={(checked) => mandatoryHandle(checked, switches[single])}
          defaultChecked={false}
          checked={checked.indexOf(switches[single]) !== -1 ? true : false}
        />
      </div>
    );
  });
  const inputs = Object.keys(options).map((option, ind) => {
    const loadedResponses = responseLoader(responseList);
    return (
      <div className={classes.responseHolder}>
        {option === selected ? (
          <input
            checked
            onChange={optionChangeHandler}
            name="selectResponseType"
            value={option}
            type="radio"
          />
        ) : (
          <input
            onChange={optionChangeHandler}
            name="selectResponseType"
            value={option}
            type="radio"
          />
        )}

        <div className={classes.responsePreview}>
          {options[option].type === 1 ? (
            <InputNumber
              min={1}
              max={10}
              defaultValue={3}
              className={classes.intInput}
            ></InputNumber>
          ) : (
            
            loadedResponses[option]
            
          )}
        </div>
      </div>
    );
  });

  return (
    <>
      {backrop}
      <div
        className={
          visible
            ? [classes.layover, classes["layover-visible"]].join(" ")
            : [classes.noGlitch, classes.layover].join(" ")
        }
      >
        <Collapsable
          inputs={inputs}
          creatable={[true, newReponseHandler]}
          heading={"select global question response type"}
          collapseClass={classes.collapseBody}
        />
        <Collapsable inputs={switchInputs} heading={"mandatory"} />
        {/* <Collapsable inputs={null} heading={"mandatory"}/> */}

        <button onClick={deleteHandler} className={classes.deletebtn}>
          Delete Clause
        </button>
      </div>
      <Draggable newResponseHandler={newReponseHandler} dragOut={drawer} />
    </>
  );
};

export default Response;
